import { createFileRoute } from '@tanstack/react-router'

import { RecentLots } from '@/features/shelf/RecentLots'

export const Route = createFileRoute('/shelf/recent')({ component: RecentLots })
